<template>
  <div class="view box grow">
    <page-headers
      :header="'Threat Progressions'"
      :breadcrumbs="breadcrumbs"
      :is-border="true"
      documentation="page-progressions"
      class="box"
    >
    </page-headers>
    <div class="full-height" v-loading="isIocDetectionsLoading || isLoading">
      <div class="table-toolbar" v-if="accountKeyThreatProgressionsReqStatus === 'saved'">
        <table-toolbar
          :key="trailInfoCollection.key"
          v-if="visibleTrailColumns"
          :search-properties="visibleTrailColumns"
          :total-search-properties="trailColumns"
          :search-data="trailInfoCollection"
          :initial-tags="trailInfoCollection.searchTags"
          :reload-component="trailInfoCollection.reloadToolbar"
          @update-querydata="updateTableQueryData"
          @refresh-tabledata="refreshTableData"
          @update-columns-data="modifyColumnsData"
        >
          <div slot="local-actions">
            <el-button :disabled="disabledMitigateSelectedProgressions" @click="openMitigateDialog" size="medium"
              >Mitigate</el-button
            >
          </div>
          <div slot="local-helper" class="search-reset">
            <div class="grid-content helper-message">
              <p v-if="$route.query.accountKey">
                Showing progressions for {{ $route.query.nickName || $route.query.accountKey }}
              </p>
              <p v-else>Showing progressions for Integration Accounts</p>
              <el-button type="text" class="icon-text-button" @click="gotoParentPage">
                <i class="material-icons c-icon"></i><span>Reset</span>
              </el-button>
            </div>
          </div>
        </table-toolbar>
      </div>

      <multi-select-action-table-element
        v-if="accountKeyThreatProgressionsReqStatus === 'saved'"
        ref="attacksTable"
        :columns="visibleTrailColumns"
        :table-data="trailInfoCollection"
        :height-offset="295"
        :actions="tableActions"
        @update-record-count="recordCountHandler"
        @table-selection-change="canMitigateSelectedProgressions"
      ></multi-select-action-table-element>

      <el-dialog :title="dialogueBoxTitle" :visible.sync="openAssignToDialogVisible">
      <el-form :model="selectedAttackTrail" v-if="usersListStatus == 'saved'">
        <div class="container">
          <div class="left" style="color:#454B60">
          <el-form-item label="Assignee" prop="email">
            <div style="margin-left: 96px;">
            <el-select
              class="threat-assignee_dropdown"
              @change="handleThreatHandoffAssigneeChange"
              v-model="selectedAttackTrail.assignTo"
              filterable
              :placeholder="selectedAttackTrail.ownerId ? selectedAttackTrail.ownerId.fullname : 'Unassigned'"
            >
              <user-button slot="prefix"
                :classList="selectedAttackTrail.assignTo ? 'shamrock-200': '' "
                :user="selectedAssignee"
              ></user-button>
              <el-option
                v-for="item in usersList.models"
                :key="item.email"
                :label="`${item.firstname} ${item.lastname}`"
                :value="item.email"
              ></el-option>
            </el-select>
            </div>
          </el-form-item>
          <el-form-item label="Status">
            <div style="margin-left:96px;">
            <el-select v-model="selectedTrailDetailsForJira.status" placeholder="Mitigation Not Started" :disabled="!checked">
              <el-option
                v-for="item in jiraTicketStatusValues"
                :key="item"
                :label="item"
                :value="item"
              ></el-option>
            </el-select>
            </div>
          </el-form-item>
          <div style="display:inline">
            <span style="font-weight: 500;"> Comment </span>
            <el-input style="display:inline"
              type="textarea"
              rows="5"
              v-model="selectedTrailDetailsForJira.comments"
            ></el-input>
          </div>
          </div>
          <div class="right">
            <div style="margin-left:39px;">
              <div style="display:flex;">
              <div>
              <span>
                <img style="width:42px; height:44.7px; margin-left:15px;" src="/static/images/logos/jira_image.svg" alt="jira-icon" />
              </span>
              </div>
              <div style="margin-top:13px;">
              <span class="jira-text-integrate-with-jira">
                Create Jira ticket*
              </span>
              <el-checkbox style="margin-left:10px;" v-model="checked" :disabled="disableCheckboxOnPopUp"></el-checkbox>
              </div>
            </div>
            </div>
            <div class="the-title-of-threat-copy">
              <span>
                Threat Progression and description<br />
                will appear as Jira issue.
              </span>
            </div>

            <div v-if="checked">
              <div class="jira-project-alignment">
                <el-form-item class="jira-project-selection" label="Jira Project">
                  <div style="margin-left:70px;">
                    <el-select
                      v-model="selectedTrailDetailsForJira.projectId"
                      filterable
                      :placeholder="jiraTicketDetails.project_key ? jiraTicketDetails.project_key : 'Select or add Jira project'"
                    >
                      <el-option
                        v-for="item in jiraSettings"
                          :key="item.id"
                          :label="item.project_id"
                          :value="item.project_id"
                      ></el-option>
                      <div style="margin-top:5px; margin-bottom:5px;" v-if="$allow('users', 'write')">
                      <el-divider direction="horizontal"></el-divider>
                      </div>
                      <router-link :to="{ name: 'integration-workflow', params: { integrationType: 'jira' } }" v-if="$allow('users', 'write')">
                        <a style="margin-left:21px;">+ Add new Jira project</a>
                      </router-link>
                    </el-select>
                  </div>
                </el-form-item>
              </div>
              <div class="jira-issue-alignment">
                <span class="jira-issue-selection">Issue</span>
                <el-radio v-model="radio" label="1">Task</el-radio>
                <el-radio v-model="radio" label="2">Story</el-radio>
                <el-radio v-model="radio" label="3">Bug</el-radio>
              </div>

              <div class="pointer-message-jira">
                * If you don’t see Assignee in Jira, your people <br />
                list is not in sync. You’ll need to Assign the <br />
                issue again inside Jira.
              </div>
            </div>
          </div>
          </div>
      </el-form>

      <div class="jira-button-alignment">
        <span slot="footer" class="dialog-footer">
          <el-button class="btn-cancel" @click="openAssignToDialogVisible = false">
            <span class="styl-cancel" >Cancel</span>
          </el-button>
          <el-button class="btn-confirm" type="primary" @click="assignTrailWork(selectedAttackTrail)">
            <span class="styl-confirm" >Confirm</span>
          </el-button>
        </span>
      </div>
    </el-dialog>

    <el-dialog title="Mitigate the Selected Progression" :visible.sync="openMitigateCurrentProgression">
      <el-form>
        <label>
          Are you sure you want to mitigate the following progression?
        </label>

        <h6><br />Progressions selected:</h6>
        <span>{{ selectedAttackTrail.trailIdLabel }}</span>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button
          @click="
            openMitigateCurrentProgression = false
            disabledMitigateCurrentProgressions = false
          "
          >Cancel</el-button
        >
        <el-button type="primary" @click="mitigateCurrentProgression(selectedAttackTrail)">Confirm</el-button>
      </span>
    </el-dialog>

    <el-dialog style="text-align:center;" :visible.sync="openSuccessDialogue">
      <div>
        <div class="success-header">
          Success!
        </div>
        <div>
          <div style="jira-success-img-alignment">
            <img src="/static/images/jira-success-logo.svg">
          </div>
          <div v-if="checkForSuccessBox" style="height:200px; overflow-y:scroll">
            <p>Following threat Progressions may now be tracked in Jira.</p>
            <div>
              <li v-for="rec of mitigatedProgressionObject" :key="rec.trailID">
                Trail ID:
                <router-link :to="{ name: 'attack-track-details', params: { trailId: rec.trailID }}"
                  >{{ rec.trailIDLabel }}
                </router-link> ,

                Ticket link: <span v-if="rec.ticketLink !== 'N/A'"><a :href="rec.ticketLink" target="_blank">click here</a></span><span v-else>N/A</span>
              </li>
            </div>
          </div>
          <div v-else>
            <p v-if ="disableCheckboxOnPopUp">Jira ticket for {{ selectedAttackTrail.trailIdLabel }} has been updated.</p>
            <p v-else>Threat Progression {{ selectedAttackTrail.trailIdLabel }} may now be tracked in Jira.</p>
            <p>Your Jira ticket number is: <span style="font-weight:600">{{ jiraTicketDetails.ticket_key }} </span></p>
          </div>
        </div>
        <div class="goto-jira-btn">
          <div>
            <a class="style-goto-jira"
            :href="jiraTicketDetails.jira_ticket_link"
            target="_blank"
            ><span>Go to Jira</span>
            </a>
          </div>
        </div>
      </div>
    </el-dialog>

      <el-dialog title="Mitigate the Selected Progression(s)" :visible.sync="openMitigateDialogVisible">
        <el-form>
          <label>
            Are you sure you want to mitigate the following progressions?
          </label>

          <h6><br />Progressions selected:</h6>
          <span v-for="(progression, idx) in selectedProgressions" :key="idx">
            {{ progression.trailIdLabel }}
            <el-divider v-if="idx !== selectedProgressions.length - 1" direction="vertical"></el-divider>
          </span>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button
            @click="
              openMitigateDialogVisible = false
              disabledMitigateSelectedProgressions = false
            "
            >Cancel</el-button
          >
          <el-button type="primary" @click="mitigateSelectedProgressions">Confirm</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageHeaders from '@/components/layout/PageHeaders.vue'
import TableToolbar from '@/components/table/TableToolbar.vue'
import UserButton from '@/components/button/UserButton.vue'
import MultiSelectActionTableElement from '@/components/table/MultiSelectActionTableElement.vue'
import AsideSidebar from '@/components/layout/AsideSidebar.vue'
import ProcessLineageGraph from '@/components/graph/ProcessLineageGraph.vue'
import IocMultiEventDetails from '@/components/feed/ioc-details/IocMultiEventDetails.vue'

import { getUserFriendlyTrailLabel } from '@/utilities/trail.helper'
import { trailsMetaInfo } from '@/column-header/trail/trails-meta'

import {
  ACCOUNT_KEY_PROGRESSIONS_REQ,
  ACCOUNT_KEY_PROGRESSIONS_SUCCESS,
  MULTIPLE_ACCOUNT_KEY_PROGRESSIONS_REQ,
  BULK_TRAIL_MITIGATION_REQ,
  TRAIL_ASSIGN_REQ,
  TRAIL_MITIGATION_REQ,
  ACTIVE_PROGRESSION_VIEW_PREFERENCES_REQ,
  SAVE_ACTIVE_PROGRESSION_VIEW_PREFERENCES
} from '@/store/modules/trails/trailsinfo.type'
import { PREFERENCE_STORE_REQ } from '@/store/modules/column-preference/column-preference.type'
import { USER_LIST_REQUEST, USER_LIST_SUCCESS } from '@/store/modules/user/user.type'
import {
  JIRA_CREATE_TICKET,
  JIRA_SETTING_REQUEST,
  JIRA_TICKET_FETCH_DETAILS,
  JIRA_ALL_TICKETS,
  JIRA_FETCH_TICKETS,
  JIRA_TICKET_STATUS_CHANGE
} from '@/store/modules/jira/jira-setting.type'

export default {
  name: 'AccountKeyProgressions',
  beforeRouteEnter (to, from, next) {
    next(vm => {
      vm.prevRoute = from
    })
  },
  data () {
    return {
      tableName: "Progression",
      progressionColumnPrefs: {},
      helperMessage: 'Help Message Here',
      breadcrumbs: this.threatBreadCrumb,
      trailColumns: trailsMetaInfo.meta.columns,
      visibleTrailColumns: [],
      trailInfoCollection: {},
      selectedAttackTrail: {},
      selectedProgressions: [],
      isLoading: false,
      openAssignToDialogVisible: false,
      openMitigateDialogVisible: false,
      disabledMitigateSelectedProgressions: true,
      tableActions: [
        {
          name: 'handoff',
          icon: 'material-icons c-icon',
          iconSubject: 'person_add_alt_1',
          tooltip: 'Handoff Progression',
          rbac: {
            subject: 'cyber_attacks',
            operation: 'write'
          },
          actionHandler: selection => {
            this.handoffTrail(selection.row)
          }
        }
      ],
      checked: false,
      radio: '',
      selectedTrailDetailsForJira: {},
      jiraTicketStatusValues: ['Mitigation Not Started', 'Mitigation in Progress', 'Mitigated'],
      dialogueBoxTitle: '',
      tblId: 3,
      openSuccessDialogue: false, // for success screen after ticket creation.
      openMitigateCurrentProgression: false, // for Mitigate confirmation
      disabledMitigateCurrentProgressions: true,
      selectedAssignee: {},
      checkForSuccessBox: false,
      mitigatedProgressionObject: [],
      disableCheckboxOnPopUp: false
    }
  },
  created () {
    let tableMetaData = {
      activePage: 1,
      searchTags: []
    }

    this.callApi(tableMetaData)
    this.loadProgressionColumnPreferences();
    this.$store.dispatch(JIRA_SETTING_REQUEST);
  },
  methods: {
    gotoParentPage () {
      this.$router.push({ name: 'active-cyber-attacks' })
    },
    getFriendlyTrailLabel (val) {
      return getUserFriendlyTrailLabel(val)
    },
    gotoDetails (trailId) {
      this.$router.push({
        name: 'attack-track-details',
        params: { trailId: trailId }
      })
    },
    fetchJiraTickets () {
      this.$store.dispatch(JIRA_ALL_TICKETS).then(() => {
        let allTicketIds = []
        for (let i of this.jiraAllTickets) {
          allTicketIds.push(i.trail_id);
        }
        for (let entry of this.trailInfoCollection.models) {
          if (allTicketIds.includes(entry.id)) {
            let currentTrail = this.jiraAllTickets.filter(rec => rec.trail_id === entry.id)
            entry.jiraTicketLink = currentTrail[0].jira_ticket_link
            entry.jiraTicketId = currentTrail[0].ticket_key
            entry.stringify += entry.jiraTicketId.toLowerCase()
          } else {
            entry.jiraTicketLink = ""
            entry.jiraTicketId = "N/A"
          }
        }
      })
    },
    handoffTrail (trail) {
      this.checkForSuccessBox = false
      this.checked = false // This is for IntegrateWithJira checkbox handling.
      this.selectedAssignee = _.cloneDeep(trail.ownerId)
      this.selectedAttackTrail = trail
      this.$store.dispatch(JIRA_TICKET_FETCH_DETAILS, {
        selectedTrail: this.selectedAttackTrail.trailIdHash
      }).then(_ => {
        if (this.jiraTicketDetails.issue_type === 'Task') {
          this.radio = "1"
          this.checked = true
          this.disableCheckboxOnPopUp = true
        } else if (this.jiraTicketDetails.issue_type === 'Story') {
          this.radio = "2"
          this.checked = true
          this.disableCheckboxOnPopUp = true
        } else if (this.jiraTicketDetails.issue_type === 'Bug') {
          this.radio = "3"
          this.checked = true
          this.disableCheckboxOnPopUp = true
        } else {
          this.radio = ''
          this.checked = false
          this.disableCheckboxOnPopUp = false
        }

        // This section is responsible for Jira Ticket Status and Confluera progression's sync.
        if (this.jiraTicketDetails.status === 'Done') {
          this.jiraTicketDetails.status = 'Mitigated'
          this.selectedTrailDetailsForJira = this.jiraTicketDetails
        } else if (this.jiraTicketDetails.status === 'To Do') {
          this.jiraTicketDetails.status = 'Mitigation Not Started'
          this.selectedTrailDetailsForJira = this.jiraTicketDetails
        } else if (this.jiraTicketDetails.status === 'In Progress') {
          this.jiraTicketDetails.status = 'Mitigation in Progress'
          this.selectedTrailDetailsForJira = this.jiraTicketDetails
        } else {
          this.selectedTrailDetailsForJira = {}
        }
      })
      this.dialogueBoxTitle = `Threat Progression ${this.selectedAttackTrail.trailIdLabel}`
      this.openAssignToDialogVisible = true
    },
    assignTrailWork(selectedTrail) {
      // Added selectedTrail.ownerId.email for syncing Assignee.
      selectedTrail.comments = this.selectedTrailDetailsForJira.comments
      if (selectedTrail.assignTo || selectedTrail.ownerId.email) {
        this.$store
          .dispatch(TRAIL_ASSIGN_REQ, {
            assignFrom: this.userProfile.email,
            assignTo: selectedTrail.assignTo ? selectedTrail.assignTo : selectedTrail.ownerId.email,
            trailId: selectedTrail.trailIdHash,
            comments: selectedTrail.comments
          })
          .then(
            () => {
              let assignedToUser = _.find(this.usersList.models, {
                email: selectedTrail.assignTo ? selectedTrail.assignTo : selectedTrail.ownerId.email
              })
              this.selectedAttackTrail.setOwnerId(assignedToUser)
              this.openAssignToDialogVisible = false

              if (this.checked) {
                // This section is responsible for Jira Ticket Status and Confluera progression's sync.
                if (this.selectedTrailDetailsForJira.status === 'Mitigation Not Started' || typeof this.selectedTrailDetailsForJira.status === 'undefined') {
                  this.selectedTrailDetailsForJira.status = 'To Do'
                } else if (this.selectedTrailDetailsForJira.status === 'Mitigated') {
                  this.selectedTrailDetailsForJira.status = 'Done'
                } else {
                  this.selectedTrailDetailsForJira.status = 'In Progress'
                }

                let payload = {
                  action_name: 'Progression_Assignment',
                  trail_id: selectedTrail.trailIdHash,
                  trail_id_label: selectedTrail.trailIdLabel,
                  target_user: assignedToUser.fullname,
                  project_id: this.selectedTrailDetailsForJira.projectId ? this.selectedTrailDetailsForJira.projectId : this.jiraTicketDetails.project_key,
                  status: this.selectedTrailDetailsForJira.status
                    ? this.selectedTrailDetailsForJira.status
                    : this.jiraTicketDetails.status,
                  type_of_ticket: this.radio,
                  description: selectedTrail.comments
                    ? selectedTrail.comments
                    : (this.jiraTicketDetails.ticket_description
                      ? this.jiraTicketDetails.ticket_description
                      : selectedTrail.trailIdLabel
                    ),
                  assignee_email: selectedTrail.assignTo ? selectedTrail.assignTo : selectedTrail.ownerId.email
                }
                if (typeof this.jiraTicketDetails !== 'undefined') {
                  if (payload.status === "Done") {
                    const comment = payload.description
                    // payload.description = 'Some Random text'
                    this.$store.dispatch(JIRA_CREATE_TICKET, payload).then(_ => {
                      let payloadForComment = {
                        trail_id: selectedTrail.trailIdHash,
                        status_type: "In Progress",
                        comment_for_ticket: comment
                      }
                      this.$store.dispatch(JIRA_TICKET_STATUS_CHANGE, payloadForComment).then(_ => {
                        this.fetchJiraTickets();
                        this.checkForSelectedMitigation()
                        this.selectedTrailDetailsForJira.status = ''
                      });
                    })
                  } else {
                    this.$store.dispatch(JIRA_CREATE_TICKET, payload).then(() => {
                      const comment = payload.description
                      // payload.description = 'Some Random text'
                      const payloadForComment = {
                        trail_id: selectedTrail.trailIdHash,
                        status_type: payload.status,
                        comment_for_ticket: comment
                      }
                      if (typeof selectedTrail.comments === 'undefined') {
                        this.fetchJiraTickets();
                        this.selectedTrailDetailsForJira.status = ''
                        this.$store.dispatch(JIRA_TICKET_FETCH_DETAILS, {
                          selectedTrail: this.selectedAttackTrail.trailIdHash
                        }).then(_ => {
                          this.openSuccessDialogue = true
                        })
                      } else {
                        this.$store.dispatch(JIRA_TICKET_STATUS_CHANGE, payloadForComment).then(_ => {
                          this.fetchJiraTickets();
                          this.selectedTrailDetailsForJira.status = ''
                          this.$store.dispatch(JIRA_TICKET_FETCH_DETAILS, {
                            selectedTrail: this.selectedAttackTrail.trailIdHash
                          }).then(_ => {
                            this.openSuccessDialogue = true
                          })
                        });
                      }
                    })
                    this.selectedTrailDetailsForJira.status = ''
                  }
                } else {
                  if (payload.status === "Done") {
                    this.$store.dispatch(JIRA_CREATE_TICKET, payload).then(_ => {
                      this.fetchJiraTickets();
                      this.checkForSelectedMitigation()
                      this.selectedTrailDetailsForJira.status = ''
                    })
                  } else {
                    this.$store.dispatch(JIRA_CREATE_TICKET, payload).then(() => {
                      this.fetchJiraTickets();
                      this.$store.dispatch(JIRA_TICKET_FETCH_DETAILS, {
                        selectedTrail: this.selectedAttackTrail.trailIdHash
                      }).then(_ => {
                        this.openSuccessDialogue = true
                      })
                    })
                    this.selectedTrailDetailsForJira.status = ''
                  }
                }
              } else {
                if (this.selectedTrailDetailsForJira.status === 'Done') {
                  this.checkForSelectedMitigation()
                }
              }
              this.$message({
                type: 'success',
                message: `Threat Progression ${_.has(selectedTrail, 'trailIdLabel') &&
                  selectedTrail.trailIdLabel ? selectedTrail.trailIdLabel : selectedTrail.trailIdHash}
                  is now assigned to ${selectedTrail.assignTo ? selectedTrail.assignTo : selectedTrail.ownerId.email}.`
              })
            },
            errMsg => {
              // keep open & show error
              this.$message({
                type: 'error',
                message: errMsg.data.message || `Something went wrong.`
              })
              this.openAssignToDialogVisible = true
            }
          )
      } else {
        this.$message({
          type: 'error',
          message: `Something went wrong. (select assignee and status)`
        })
      }
    },
    assignToSelf (trail) {
      // this vue module instance
      let vm = this
      this.$confirm(`This will assign ${trail.trailIdHash} to yourself. Continue?`, 'Assign to Self', {
        confirmButtonText: 'OK',
        cancelButtonText: 'Cancel',
        callback: function (action) {
          if (action == 'confirm') {
            vm.$store
              .dispatch(TRAIL_ASSIGN_REQ, {
                assignFrom: vm.userProfile.email,
                assignTo: vm.userProfile.email,
                trailId: trail.trailIdHash
              })
              .then(
                () => {
                  vm.$message({
                    type: 'success',
                    message: `Threat Progression ${trail.trailIdHash} is now assigned to you.`
                  })
                },
                errMsg => {}
              )
          } else if (action == 'cancel') {
            vm.$message({
              type: 'info',
              message: `Assignment canceled`
            })
          }
        }
      })
    },
    updateTableQueryData () {
      if (_.isEmpty(this.trailInfoCollection.searchTags)) {
        this.gotoParentPage()
      }
      if (this.$refs.attacksTable) {
        this.$refs.attacksTable.updateTableData()
      }
    },
    recordCountHandler () {
      // key is used to re-render TableToolbar component
      // on page change to update 'queryCountText'
      this.trailInfoCollection.key = !this.trailInfoCollection.key
      this.trailInfoCollection.reloadToolbar = false
    },
    modifyColumnsData (selectedColumns) {
      this.progressionColumnPrefs.userId = this.userProfile.id;
      this.progressionColumnPrefs.tblName = this.tableName;
      this.progressionColumnPrefs.preferedCols = selectedColumns.length === 0 ? NaN : selectedColumns;
      this.progressionColumnPrefs.tblId = 3;

      this.visibleTrailColumns = this.trailInfoCollection.updateVisibleColumns(this.trailColumns, selectedColumns)

      this.$store.dispatch(SAVE_ACTIVE_PROGRESSION_VIEW_PREFERENCES, this.progressionColumnPrefs).then(
        data => {
          // store preferences in vuex
          this.progressionColumnPrefs.preferedCols = this.visibleTrailColumns;
          this.$store.dispatch(PREFERENCE_STORE_REQ, this.progressionColumnPrefs)
            .then(_ => {
              this.$refs.attacksTable.refreshLayout()
            })
        })
    },
    refreshTableData (tableMetaData) {
      this.callApi(tableMetaData)
    },
    loadProgressionColumnPreferences() {
      // check if already present in store
      if (_.has(this.userPref, this.userProfile.id) && _.has(this.userPref[this.userProfile.id], this.tableName)) {
        //  read values from store
        this.visibleTrailColumns = this.userPref[this.userProfile.id][this.tableName]
        // this.updateStoreWithPrefs()
      } else {
        // fetch from database
        this.$store.dispatch(ACTIVE_PROGRESSION_VIEW_PREFERENCES_REQ, this.userProfile.id)
          .then(data => {
            this.visibleTrailColumns = this.trailColumns.filter(col => {
              return this.activeProgressionPreferences.includes(col.label)
            })
            this.updateStoreWithPrefs()
          })
      }
    },
    updateStoreWithPrefs () {
      this.progressionColumnPrefs = {
        userId: this.userProfile.id,
        tblName: this.tableName,
        preferedCols: this.visibleTrailColumns
      }

      this.$store.dispatch(PREFERENCE_STORE_REQ, this.progressionColumnPrefs);
    },
    getProgressionsByAccountKey (tableMetaData) {
      this.$store
        .dispatch(ACCOUNT_KEY_PROGRESSIONS_REQ, {
          accountKey: this.$route.query.accountKey
        })
        .then(detections => {
          this.trailInfoCollection = detections
          this.$store.dispatch(USER_LIST_SUCCESS)
          this.$store.dispatch(ACCOUNT_KEY_PROGRESSIONS_SUCCESS)
          this.setTableMetaData(tableMetaData)
          this.isLoading = false
          this.fetchJiraTickets();
        })
    },
    getProgressionsByListOfAccountKeys (tableMetaData) {
      this.$store
        .dispatch(MULTIPLE_ACCOUNT_KEY_PROGRESSIONS_REQ, {
          accountKeys: this.$route.query.accountKeys
        })
        .then(detections => {
          this.trailInfoCollection = detections
          this.$store.dispatch(USER_LIST_SUCCESS)
          this.$store.dispatch(ACCOUNT_KEY_PROGRESSIONS_SUCCESS)
          this.setTableMetaData(tableMetaData)
          this.isLoading = false
          this.fetchJiraTickets();
        })
    },
    callApi (tableMetaData) {
      this.isLoading = true
      if (this.usersListStatus !== 'saved') {
        this.$store.dispatch(USER_LIST_REQUEST).then(data => {
          this.$store.dispatch(USER_LIST_SUCCESS)
        })
      }

      if (!this.$_.isEmpty(this.$route.query.accountKey)) {
        this.getProgressionsByAccountKey(tableMetaData)
      } else if (!this.$_.isEmpty(this.$route.query.accountKeys)) {
        this.getProgressionsByListOfAccountKeys(tableMetaData)
      } else {
        this.$store
          .dispatch(ACCOUNT_KEY_PROGRESSIONS_REQ)
          .then(detections => {
            this.trailInfoCollection = detections
            this.$store.dispatch(USER_LIST_SUCCESS)
            this.$store.dispatch(ACCOUNT_KEY_PROGRESSIONS_SUCCESS)
            this.setTableMetaData(tableMetaData)
            this.isLoading = false
            this.fetchJiraTickets();
          })
      }
    },
    setTableMetaData (tableMetaData) {
      this.trailInfoCollection.searchTags = tableMetaData.searchTags
      this.trailInfoCollection.currentPage = tableMetaData.activePage
    },
    canMitigateSelectedProgressions () {
      if (this.$refs.attacksTable.rowsSelected.length > 0) {
        this.disabledMitigateSelectedProgressions = false
      } else {
        this.disabledMitigateSelectedProgressions = true
      }
    },
    openMitigateDialog () {
      this.selectedProgressions = this.$refs.attacksTable.rowsSelected
      this.openMitigateDialogVisible = true
    },
    mitigateSelectedProgressions () {
      this.checkForSuccessBox = false
      this.disabledMitigateSelectedProgressions = true
      let email = this.userProfile.email
      let trailIds = []
      let trailIdLabels = []
      this.$refs.attacksTable.rowsSelected.forEach(trail => {
        trailIds.push(trail.id)
        trailIdLabels.push(trail.trailIdLabel)
      })

      this.$store
        .dispatch(BULK_TRAIL_MITIGATION_REQ, {
          assignFrom: email,
          assignTo: email,
          trails: trailIds
        })
        .then(() => {
          this.disabledMitigateSelectedProgressions = false
          this.openMitigateDialogVisible = false
          this.$store.dispatch(JIRA_FETCH_TICKETS).then(_ => {
            for (let trail of trailIds) {
              if (this.fetchTickets.includes(trail)) {
                let payload = {
                  trail_id: trail,
                  status_type: "Mitigated",
                  comment_for_ticket: 'Trail has been mitigated'
                }
                this.$store.dispatch(JIRA_TICKET_STATUS_CHANGE, payload);
              }
            }
            this.mitigatedProgressionObject = []
            let temp = []
            for (let id of trailIds) {
              if (this.fetchTickets.includes(id)) {
                for (let ticket of this.jiraAllTickets) {
                  if (ticket.trail_id === id) {
                    temp.push(ticket.jira_ticket_link)
                    break;
                  }
                }
              } else {
                temp.push('N/A') // Storing N/A inside array if ticket being not created
              }
            }
            for (let cnt = 0; cnt < trailIds.length; cnt++) {
              let obj = {
                'trailID': trailIds[cnt],
                'ticketLink': temp[cnt],
                'trailIDLabel': trailIdLabels[cnt]
              }
              this.mitigatedProgressionObject.push(obj);
            }
            this.checkForSuccessBox = true // For checking whether a single progression or list of progression selected
            this.openSuccessDialogue = true
          })
          this.refreshTableData({
            activePage: 1,
            searchTags: this.trailInfoCollection.searchTags
          })
        })
    },
    gotoTrails () {
      this.$router.push({ name: 'active-cyber-attacks' })
      this.openSuccessDialogue = false
    },
    checkForSelectedMitigation (currentSelectedTrail) {
      this.disabledMitigateCurrentProgressions = true
      this.openMitigateCurrentProgression = true
    },
    mitigateCurrentProgression (currentSelectedTrail) {
      this.$store
        .dispatch(TRAIL_MITIGATION_REQ, {
          assignFrom: this.userProfile.email,
          assignTo: this.userProfile.email,
          trailId: currentSelectedTrail.trailIdHash
        })
        .then(
          () => {
            this.disabledMitigateCurrentProgressions = false
            this.openMitigateCurrentProgression = false
            this.$store.dispatch(JIRA_FETCH_TICKETS).then(_ => {
              if (this.fetchTickets.includes(currentSelectedTrail.trailIdHash)) {
                let payload = {
                  trail_id: currentSelectedTrail.trailIdHash,
                  status_type: "Mitigated",
                  comment_for_ticket: 'Trail has been mitigated'
                }
                this.$store.dispatch(JIRA_TICKET_STATUS_CHANGE, payload).then(_ => {
                  this.$store.dispatch(JIRA_TICKET_FETCH_DETAILS, {
                    selectedTrail: currentSelectedTrail.trailIdHash
                  }).then(_ => {
                    this.openSuccessDialogue = true
                  })
                });
              }
            })
          },
          errMsg => {
            this.openMitigateCurrentProgression = false
            this.disabledMitigateCurrentProgressions = false
          }
        )
    },
    handleThreatHandoffAssigneeChange () {
      const selectedUser = this.usersList.models.filter(user => user.email === this.selectedAttackTrail.assignTo)
      this.selectedAssignee = _.cloneDeep(selectedUser[0])
    }
  },
  watch: {},
  beforeMount () {
    this.breadcrumbs = this.threatBreadCrumb
  },
  computed: {
    isIocDetectionsLoading () {
      return this.accountKeyThreatProgressionsReqStatus === 'loading'
    },
    threatBreadCrumb () {
      return [
        { title: 'Threats' },
        { title: 'Progressions', to: '/monitor/cyber-attacks/active' },
        { title: this.$route.query.nickName || this.$route.query.accountKey }
      ]
    },
    ...mapGetters([
      'accountKeyThreatProgressionsReqStatus',
      'accountKeyThreatProgressionsList',
      'rulesListReqStatus',
      'agentListReqStatus',
      'mitreTacticListReqStatus',
      'iocDetailsReqStatus',
      'insightsEnabled',
      'userProfile',
      'usersList',
      'usersListStatus',
      'trailsAssignmentStatus',
      'projectIds',
      'jiraSettings',
      'jiraTicketDetails',
      'jiraAllTickets',
      'fetchTickets',
      'activeProgressionPreferences',
      'userPref'
    ])
  },
  components: {
    PageHeaders,
    MultiSelectActionTableElement,
    TableToolbar,
    AsideSidebar,
    ProcessLineageGraph,
    IocMultiEventDetails,
    UserButton
  }
}
</script>

<style scoped>
@import 'assets/styles/_variables.css';

.process-lineage-details {
  >>> .aside-sidebar {
    width: 50% !important;
  }
}

.heading {
  .fal {
    background: #e07373;
    border-radius: 50%;
  }

  .box {
    min-width: 25px;

    .score {
      color: var(--gray-600);
    }
  }

  .box.score {
    min-width: 50px;
  }
}

.search-reset {
  line-height: 36px;

  p {
    display: inline;
  }

  .icon-text-button {
    background: var(--denim-500);
    padding: 5px 10px;
    vertical-align: middle;

    span {
      color: white;
    }

    .c-icon {
      margin-right: 0px !important;
    }
  }

  .helper-message {
    background: var(--denim-50);
    padding: 20px;
  }
}

.local-trailid {
  .material-icons {
    font-size: 14px;
    vertical-align: middle;
  }
}

.el-form-item ::before, .el-form-item ::after{
  color: #454B60;

}

.el-form-item {
  color: #454B60;
}
.el-select {
  height: 41px;
  width: 279px;
  border-radius: 2px;
  border:1px solid #A1A8AE;
  background-color: #FFFFFF;
}

>>> .el-input--suffix .el-input__inner {
  border:none
}

.threat-assignee_dropdown {
  >>> .el-input--prefix .el-input__prefix {
    left: 13px;
  }

  >>> .el-input--suffix .el-input__inner {
    border:none;
    padding-left: 58px;
  }
}

>>> .avatar-circle,.avatar-circle:hover {
  background: #77DAB4 !important;
}

.el-radio {
  color:#454B60
}


.the-title-of-threat-copy {
  height: 48px;
  width: 298px;
  color: #454B60;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 24px;
  margin-top:12px;
  margin-left:115px;
}

.pointer-message-jira{
  height: 72px;
  width: 316px;
  color: #454B60;
  font-size: 15px;
  letter-spacing: 0;
  line-height: 24px;
  margin-top:26px;
  margin-left:115px;
}

.jira-project-selection {
  width:400px;
  margin-left: -15px;
}

.container {
  display: flex;
  flex-direction: row;
}
.left {
  height: 400px;
  display: block;
  width: 48%;
}
.right {
  height: 370px;
  display: block;
  width: 50%;
}

.btn-confirm {
  height: 36px;
  width: 132px;
  border-radius: 4px;
  background-color: #1890FA;
  justify-content: center;
  align-items: center;
  padding: 0px;
}

.btn-cancel {
  box-sizing: border-box;
  height: 36px;
  width: 132px;
  border: 1px solid #A1A8AE;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  padding: 0px;
}

.styl-cancel {
  height: 20px;
  width: 68px;
  color: #454B60;;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.1px;
  line-height: 20px;
  text-align: center;
}

.styl-confirm {
  height: 20px;
  width: 68px;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  line-height: 20px;
  text-align: center;
}

>>> .el-form-item__label {
 color: #454B60;
 font-weight: 500;
}

>>> .el-textarea__inner{
    width: 279px;
    margin-left: 98px;
    margin-top: -15px;
    border: 1px solid #A1A8AE;
}

>>> .el-dialog__title {
  height: 35px;
  width: 428px;
  color: #454B60;
  font-size: 30px;
  font-weight: 300;
  letter-spacing: 0;
  line-height: 35px;
}

>>> .el-dialog__body {
  padding-left:63px;
  padding-right: 73px;
}

>>> .el-dialog__header {
  padding: 36px 28px 10px;
  margin-left:30px;
}

>>> .el-dialog {
  border-radius: 7px;
  width: 965px;
  height: 591px;
}

>>> .el-radio {
  width: 49px;
}

.jira-text-integrate-with-jira {
  /* color:#454B60;
  font-weight: 500; */
  height: 24px;
  width: 137px;
  color: #454B60;
  /* font-family: Montserrat; */
  font-size: 15px;
  font-weight: 600;
  letter-spacing: 0;
  line-height: 24px;
  margin-left:20px;
}

.jira-issue-selection {
  margin-right:36px;
  color:#454B60;
  font-weight: 500;
}

.jira-button-alignment {
  margin-top:-28px;
  float:right;
}

.jira-project-alignment {
  margin-top:30px;
  margin-left:56px;
}

.jira-issue-alignment {
  margin-left:43px;
  margin-top:25px;
}

>>>.el-input__inner::-webkit-input-placeholder,
>>>.el-input__inner {
  color: #454B60;
}

>>>.el-textarea__inner::-webkit-input-placeholder,
>>> .el-textarea__inner {
  color: #454B60;
  /* border:1px solid #A1A8AE; */
}

>>>.el-input__inner::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #454B60;
  opacity: 1; /* Firefox */
}

>>>.el-input__inner:-ms-input-placeholder,
>>>.el-input__inner::-ms-input-placeholder {
  color: #454B60;
}


>>> .add-search-tags-btn {
  display: none;
}

>>> .vue-tags-search-box {
  position: static !important;
}

>>> .search-box {
  padding: 18px 0px;
}

.success-header {
  font-size: 30px;
  color: #297FCA;
  font-weight: 300;
  margin-top: -15px;
  margin-bottom: 65px;
}

.goto-jira-btn {
  height: 36px;
  width: 139px;
  border-radius: 4px;
  background-color: #1A90FA;
  /* align-items: center; */
  margin-left: 42%;
  margin-top: 45px;
}

.style-goto-jira {
  height: 30px;
  width: 139px;
  color: #FFFFFF;
  font-size: 14px;
  font-weight: 600;
  letter-spacing: 0.1px;
  position: absolute;
  margin-top: 7px;
  margin-left: -69px;
  text-decoration: none;
}

.jira-success-img-alignment {
  margin-top:37px;
  margin-bottom:28px;
}

.back-to-threat {
  margin-top: 20px;
  font-weight: 600;
}

>>>.el-divider--horizontal {
  margin-top:10px;
  margin-bottom:10px;
}
</style>



// WEBPACK FOOTER //
// src/views/monitor/cyber_attacks/AccountKeyProgressions.vue